<main class="mat-body" *ngIf="contract">
    <div class="container">
        <div class="row">
            <div class="col-12 pt-3">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'full-data.data-contract'|translate"></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-full-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1" />
            </div>
            <div class="col-12 mb-4">
                <thr-view-account-iban-table [iban]="contract.iban"></thr-view-account-iban-table>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <mat-accordion class="full-data" [displayMode]="'flat'" [hideToggle]="true">
                    <mat-expansion-panel
                        class="mat-elevation-z0"
                        [expanded]="true"
                        [disabled]="true"
                        (afterCollapse)="onAccordionChange()"
                        (afterExpand)="onAccordionChange()"
                    >
                        <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                            <mat-panel-title>
                                <h2 class="mat-subheading-1 mb-0">{{ 'full-data.account-ownership'|translate }}</h2>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="bg-gray-gradient pt-3 px-3 pb-5">
                            <form #formFullDataAccount="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                                <h3 class="mat-subheading-1 text-blue font-weight-bold mb-4">
                                    {{ 'full-data.provide-certain-documentation'|translate }}
                                </h3>

                                <div class="row">
                                    <div class="col-12 col-md-8 col-lg-6">
                                        <mat-form-field class="full-width mb-3 mb-sm-4">
                                            <input
                                                name="vaIban"
                                                matInput
                                                mask="SS00 0000 0000 00 0000000000"
                                                [required]="editing"
                                                maxlength="35"
                                                iban
                                                [placeholder]="'form.account-number'|translate"
                                                [disabled]="!editing"
                                                [(ngModel)]="contract.iban"
                                                (ngModelChange)="onIbanChange()"
                                                #ibanCtrl="ngModel"
                                            />
                                            <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="ibanCtrl.hasError('iban')">
                                                {{ 'form.validation.iban'|translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mat-subheading-1 text-blue font-weight-bold">
                                    {{ 'form.documents'|translate }}

                                    <mat-hint class="d-block mat-caption text-blue font-italic">
                                        {{ 'form.documents-help'|translate:{size: 6} }}
                                    </mat-hint>
                                </h3>

                                <ng-template ngFor let-document [ngForOf]="contract.documents" let-i="index">
                                    <div class="mb-4">
                                        <thr-file-selector
                                            [name]="'faDocument' + i"
                                            [label]="document.name"
                                            [filename]="document.filename"
                                            [canView]="document.id && !document.file"
                                            filesize
                                            filetype
                                            [required]="editing && (!document.optional && (!document.id || document.remove))"
                                            [disabled]="!editing"
                                            [(ngModel)]="document.file"
                                            (view)="onDocumentView(document)"
                                            (remove)="onDocumentRemove(document)"
                                            #documentCtrl="ngModel"
                                        ></thr-file-selector>
                                        <mat-error
                                            class="d-block mat-caption font-italic mt-2"
                                            *ngIf="documentCtrl.hasError('filetype') && !documentCtrl.hasError('required')"
                                        >
                                            {{ 'form.validation.filetype'|translate }}
                                        </mat-error>
                                        <mat-error
                                            class="d-block mat-caption font-italic mt-2"
                                            *ngIf="documentCtrl.hasError('filesize') && !documentCtrl.hasError('required')"
                                        >
                                            {{ 'form.validation.filesize'|translate:{size: 6} }}
                                        </mat-error>
                                        <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('required')">
                                            {{ 'form.validation.required'|translate }}
                                        </mat-error>
                                    </div>
                                </ng-template>

                                <h2
                                    class="text-blue mat-display-1 mt-5 mb-0"
                                    [innerHTML]="'form.choose-who-will-provide-correspondence'|translate"
                                ></h2>
                                <hr class="mt-1" />
                                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-4">{{ 'form.communications-info'|translate }}</h2>
                                <h3 class="mat-subheading-1 text-blue font-weight-bold my-3">{{ 'form.participants'|translate }}</h3>

                                <thr-full-data-appropriateness-table
                                    [contract]="contract"
                                    [participants]="participants"
                                    [isDisabled]="!editing"
                                ></thr-full-data-appropriateness-table>

                                <div class="row" [class.justify-content-end]="!editing" [class.justify-content-between]="editing">
                                    <ng-container *ngIf="!editing && canEdit">
                                        <div class="col-12 col-sm-6 col-md-4 mt-5">
                                            <button
                                                type="button"
                                                class="full-width mat-elevation-z0"
                                                mat-raised-button
                                                color="blue"
                                                (click)="onEdit()"
                                            >
                                                {{ 'general.edit'|translate }}
                                            </button>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="editing">
                                        <div class="col-12 col-sm-6 col-md-4 mt-5">
                                            <button
                                                type="button"
                                                class="full-width mat-elevation-z0"
                                                mat-raised-button
                                                color="gray"
                                                (click)="onCancel()"
                                            >
                                                {{ 'general.cancel'|translate }}
                                            </button>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-5">
                                            <button
                                                type="submit"
                                                class="full-width mat-elevation-z0"
                                                mat-raised-button
                                                color="blue"
                                                [disabled]="!isFormFullDataAccountValid"
                                            >
                                                {{ 'general.save'|translate }}
                                            </button>
                                            <p class="mat-caption text-error font-italic mt-3 mb-0" *ngIf="requiredDocumentProof">
                                                {{ 'full-data.upload-contract-proof'|translate }}
                                            </p>
                                        </div>
                                    </ng-container>
                                </div>
                            </form>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>
</main>
